export default __webpack_public_path__ + "static/media/down.26ee2048.svg";